/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Active
 *
 * 1 = Inactive
 */
export enum UserModuleStatus {
  Active = 0,
  Inactive = 1,
}
